import tw from "twin.macro";
import styled from "styled-components";

const EqualHeightPaddedRow = styled.div`
  ${tw`flex flex-wrap`}
  margin-right: -15px;
  margin-left: -15px;

  & > [class^="col"],
  & > [class*=" col"] {
    margin-bottom: 30px;
  }

  & .card {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
`;

export default EqualHeightPaddedRow;
